// extracted by mini-css-extract-plugin
export default {"root":"Story_root__SyXyY","inner":"Story_inner__1m6Ht","quote":"Story_quote__BkWqC","text":"Story_text__61evu"};